import { useTranslation } from 'react-i18next';
import PageHero from '../components/ui/PageHero/PageHero';
import PillLink from '../components/ui/PillLink/PillLink';
import Section from '../components/ui/Section/Section';
import { CONTACT_EMAIL, mailtoHref } from '../data/navigation';
import { usePageMeta } from '../hooks/usePageMeta';
import styles from './Contact.module.css';

export default function Contact() {
    const { t } = useTranslation();
    usePageMeta(t('meta.contactTitle'), t('meta.contactDescription'));

    const mailHref = mailtoHref(t('contactPage.mailSubject'));
    const draftHref = mailtoHref(t('contactPage.offer.mailSubject'), t('contactPage.offer.mailBody'));
    const checklist = t('contactPage.checklist.items', { returnObjects: true }) as unknown as string[];
    const steps = t('contactPage.steps.items', { returnObjects: true }) as unknown as string[];

    return (
        <>
            <PageHero title={t('contactPage.title')} lead={t('contactPage.lead')} />
            <Section theme="light" shape="sheet" labelledBy="contact-mail-title">
                <div className={`page-inner ${styles.layout}`}>
                    <div className={styles.mail}>
                        <h2 id="contact-mail-title" className="visually-hidden">{t('contactPage.mailTitle')}</h2>
                        <a className={styles.email} href={mailHref}>{CONTACT_EMAIL}</a>
                        <PillLink href={mailHref} size="large" icon="arrowRight">{t('contactPage.mailAction')}</PillLink>
                        <div className={styles.offer}>
                            <h2 className={styles.offerTitle}>{t('contactPage.offer.title')}</h2>
                            <p className={styles.offerBody}>{t('contactPage.offer.body')}</p>
                            <PillLink href={draftHref} variant="outline" icon="mail">{t('contactPage.offer.action')}</PillLink>
                        </div>
                    </div>
                    <div className={styles.aside}>
                        <div className={styles.block}>
                            <h2 className={styles.asideTitle}>{t('contactPage.checklist.title')}</h2>
                            <ul className={styles.checklist}>
                                {checklist.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                        <div className={styles.block}>
                            <h2 className={styles.asideTitle}>{t('contactPage.steps.title')}</h2>
                            <ol className={styles.steps}>
                                {steps.map((step, index) => (
                                    <li key={step} className={styles.step}>
                                        <span className={styles.stepIndex} aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
                                        <span>{step}</span>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </div>
                </div>
            </Section>
        </>
    );
}
